import {Pipe, PipeTransform} from '@angular/core';
import {TupleIdName} from '../models/tuple.model';
import {I18nService} from '../../shared/i18n';
import {ActionTypeCodebook} from '../codebook/action-type-codebook';
import {CodebookModel} from '../models/codebook.model';

@Pipe({
    name: 'actionType'
})
export class ActionTypePipe implements PipeTransform {
    private allTypes:CodebookModel[] = ActionTypeCodebook.allTypes;
    constructor() {
    }


    transform(value: any, args?: any): any {

        let  type = this.allTypes.filter(type => type.id === value)[0];
        if(type == null) {
            type = {id:-1,name:'n/a'}
        }
        return type.name;
    }


}



// WEBPACK FOOTER //
// ./src/app/+app-custom/pipes/actionType.pipe.ts